import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { ArrowRight, ArrowLeft } from "lucide-react";
import SEO from "../components/SEO";
import Logo from "../components/Logo";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user && user !== false) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      setError(err.response?.data?.detail || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-bg">
      <SEO title="Admin | B&S Global Ventures" robots="noindex, nofollow" />
      <div className="w-full max-w-md">
        <a href="/" className="inline-flex items-center gap-2 text-sm text-muted mb-8 hover:text-primary">
          <ArrowLeft size={14} /> Back to site
        </a>
        <div className="glass-card p-8 md:p-10">
          <Logo className="h-14 md:h-16 w-auto mb-6" />
          <div className="label-cap text-accent mb-3">Admin Access</div>
          <h1 className="font-serif text-3xl font-bold text-primary">Sign in to dashboard</h1>
          <form onSubmit={submit} className="mt-8 space-y-4">
            <label className="block">
              <div className="label-cap text-muted mb-2">Email</div>
              <input className="input-field" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
            </label>
            <label className="block">
              <div className="label-cap text-muted mb-2">Password</div>
              <input className="input-field" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
            </label>
            {error && <p className="text-sm text-danger">{error}</p>}
            <button type="submit" disabled={busy} className="btn-gold w-full justify-center">
              {busy ? "Signing in…" : "Sign In"} <ArrowRight size={16} />
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
